// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18u0v77o{margin-left:var(--ds-space-025,2px)}
._1nmz9jpi{word-break:break-all}
._o5721jtm{white-space:pre-wrap}
._s7n41q9y{vertical-align:baseline}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/MediaInlineCard/LoadingView/styled-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,mCAAmC;AAC9C,WAAW,oBAAoB;AAC/B,WAAW,oBAAoB;AAC/B,WAAW,uBAAuB","sourcesContent":["._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._1nmz9jpi{word-break:break-all}\n._o5721jtm{white-space:pre-wrap}\n._s7n41q9y{vertical-align:baseline}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
